export default "__VITE_ASSET__DZO7sGXB__"